import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';


import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "./DiffusionOptionsDesc.css";

import SeedImage1 from "../../../image/for-iopaint/option-description/seed/seed-compare1-h100.jpeg";
import SeedImage2 from "../../../image/for-iopaint/option-description/seed/seed-compare2-h100.jpeg";

function DiffusionOptionsDescSeed() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
          {t('diffusionOptions27', 'When images are generated by using different input value, different output images are generated, even in the condition that other input values are same.')}
          <br/>
          {t('diffusionOptions28', 'Other input values affect how different images are generated.')}
          <br/>
          {t('diffusionOptions29', 'This is useful for image variation or image output control.')}
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <img className="diffsionOptionDescImage"
              src={SeedImage1}
            />
            <img className="diffsionOptionDescImage"
              src={SeedImage2}
            />
          </div>
        </div>
      </div>
    )
  }


export default DiffusionOptionsDescSeed